<template>
  <div class="exclusiveActivities align-center-main"  v-loading="loading">
    <div class="clearfix">
      <div class="smallbox boxShadow" v-for="(item, index) in list" :key="index">
        <img :src="item.banner" alt="" @click="exclusiveActivitiesdetails(item.welfareId)">
        <div class="content imgContent">
          <h4 class="titel textOver" @click="exclusiveActivitiesdetails(item.welfareId)">{{item.title}}</h4>
          <p class="exclusive m_t5 textOver youhui" @click="exclusiveActivitiesdetails(item.welfareId)">园区用户专享：{{item.discountLimit}}</p>
          <p class="welfare" @click="exclusiveActivitiesdetails(item.welfareId)">福利来自：{{item.providerName}}</p>
          <p class="timeLimit" @click="exclusiveActivitiesdetails(item.welfareId)">有效期限：{{item.beginTime | DateFilter('yyyy-MM-dd hh:mm')}} 至 {{item.endTime | DateFilter('yyyy-MM-dd hh:mm')}}</p>
        </div>
      </div>
    </div>
    <div class="fy main-pagination" v-if="msgtotal > 20">
      <el-pagination background layout="prev, pager, next" :total="msgtotal" @current-change="handleCurrentChange" :page-size="20"></el-pagination>
    </div>

    <Nothing v-if="!list.length && !loading"></Nothing>

  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return{
      pageIndex: 1,
      msgtotal: 0,
      list:[],
      loading: true,
    }
  },
  methods:{
    exclusiveActivitiesdetails(id) {
      this.$router.push({ path: `/navigator/exclusiveActivitiesdetails/${id}` });
    },
    exclusiveList() {
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/welfare/info/list`,{
        currPage: this.pageIndex,
        pageRows: 20,
        parkId: this.currentParkId,
      }).then((res) => {
        this.loading = false;
        if (res.data.resCode === '10000') {
          this.list = res.data.resData.pageList ? res.data.resData.pageList : [];
          this.msgtotal = res.data.resData && res.data.resData.pageInfo ? res.data.resData.pageInfo.total : 0;
        }
      });
    },
    handleCurrentChange(val) {  // 改变页数
      this.pageIndex = val;
      this.exclusiveList();
    },
  },
  created() {
    this.exclusiveList();
  },
  computed: {
    ...mapGetters(['currentParkId']),
  },
}
</script>
<style scoped lang="scss">
.exclusiveActivities{
  height: 100%;
}
.smallbox{
  float: left;
  width: 580px;
  height: 126px;
  display: flex;
  margin-right: 20px;
  margin-bottom: 20px;
  &:nth-of-type(2n) {
    margin-right: 0;
  }
  img {
    width: 168px;
    height: 126px;
    cursor: pointer;
    border-radius: 4px 0 0 4px;
  }
}
.content{
  box-sizing: border-box;
  padding: 15px 0 0 20px;
  flex: 1;
  background-color: #fff;
}
.titel{
  color: #333;
  font-size: 20px;
  cursor: pointer;
  width: 400px;
  font-weight: 600;
  line-height: 30px;
}
.exclusive{
  color: #de2c32;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  width: 400px;
  margin: 5px 0;
  font-weight: 600;
}
.timeLimit{
  // font-size: 12px;
  line-height: 20px;
  cursor: pointer;
}
.welfare{
  // font-size: 12px;
  line-height: 20px;
  cursor: pointer;
}
.m_t5{
  margin-top: 5px;
}
.fy{
  text-align: center;
  margin-top: 76px;
}
.imgContent {
  .youhui {
    font-size: 14px;
  }
  p {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/parkCompleteSet/completeSet/ExclusiveActivities.vue